import React from "react";
import {
    List,
    Datagrid,
    Edit,
    Create,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from "react-admin";
import BaseForm from "../baseForm";

const form = <BaseForm fields={
    {name: '', star: 0, review: ''}
} images={
    {avatar: ''}
} selections={
    {book_id: 'book-all'}
} dateTime={
    {created_at: ''}
}/>

const BookReviewFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="name" alwaysOn/>
    </Filter>
);

export const BookReviewList = props => (
    <List {...props} filters={<BookReviewFilter/>} filter={{is_published: true}}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="star"/>
            <TextField source="book_name"/>
            <EditButton basePath="/book-review"/>
        </Datagrid>
    </List>
);

export const BookReviewEdit = props => (
    <Edit {...props}>
        {form}
    </Edit>
);

export const BookReviewCreate = props => (
    <Create title="Create a category" {...props}>
        {form}
    </Create>
);
